/**
 * Constrained Pinch-to-Zoom for touch Product Images
 * Zooms within container boundaries (like desktop magnifier)
 * Touch/coarse-input only
 */
(function() {
  'use strict';

  function hasTouchInput() {
    return ('ontouchstart' in window) ||
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
      (window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  }

  // Only run for tap/swipe-capable inputs
  if (!hasTouchInput()) return;
  
  // Global flag to prevent multiple initializations
  if (window.pinchZoomInitialized) return;
  window.pinchZoomInitialized = true;

  function initConstrainedPinchZoom() {
    var containers = document.querySelectorAll('.img-magnifier-container');
    var zoomIcon = document.querySelector('.pinch-to-zoom-icon');
    var mainCarousel = document.getElementById('sync1');
    var $mainCarousel = mainCarousel ? $(mainCarousel) : null;

    function hideZoomIcon() {
      if (zoomIcon) zoomIcon.classList.remove('is-visible');
    }

    function showZoomIconWhenImageIsRendered() {
      hideZoomIcon();
      if (!zoomIcon) return;

      var activeImage = document.querySelector('#sync1 .owl-item.active .product-main-image');
      if (!activeImage) return;

      function revealZoomIcon() {
        var currentImage = document.querySelector('#sync1 .owl-item.active .product-main-image');
        if (currentImage !== activeImage) return;

        var enabled = currentImage.dataset.zoomFailed !== 'true';
        currentImage.classList.toggle('pdp-zoom-eligible', enabled);
        if (!enabled) return;

        window.requestAnimationFrame(function() {
          window.requestAnimationFrame(function() {
            zoomIcon.classList.add('is-visible');
          });
        });
      }

      if (activeImage.complete && activeImage.naturalWidth > 0) {
        if (typeof activeImage.decode === 'function') {
          activeImage.decode().catch(function() {}).then(revealZoomIcon);
        } else {
          revealZoomIcon();
        }
      } else {
        activeImage.addEventListener('load', revealZoomIcon, { once: true });
      }
    }

    if ($mainCarousel) {
      $mainCarousel.on('change.owl.carousel', hideZoomIcon);
      $mainCarousel.on('translated.owl.carousel refreshed.owl.carousel', showZoomIconWhenImageIsRendered);
    }

    showZoomIconWhenImageIsRendered();
    
    containers.forEach(function(container) {
      var img = container.querySelector('.product-main-image');
      if (!img) return;
      
      // Mark this image as initialized to prevent duplicates
      if (img.dataset.pinchZoomInit) return;
      img.dataset.pinchZoomInit = 'true';
      
      var state = {
        scale: 1,
        posX: 0,
        posY: 0,
        startDistance: 0,
        startScale: 1,
        startX: 0,
        startY: 0,
        lastTouchX: 0,
        lastTouchY: 0,
        isZooming: false,
        isPanning: false,
        userInteracted: false, // Track if user has actively zoomed
        preventCarouselReset: false, // Flag to prevent carousel from resetting zoom
        moveDistance: 0, // Track movement for tap detection
        maxScale: 3,
        imageStatus: 'idle',
        imagePromise: null,
        pinchActive: false,
        latestPinchDistance: 0,
        zoomDisabled: false
      };
      
      // Get carousel reference
      var carousel = document.getElementById('sync1');
      var $carousel = carousel ? $(carousel) : null;
      
      // Simple carousel disable - only toggle options, no event unbinding
      function disableCarouselDrag() {
        if (!$carousel) return;
        var owlData = $carousel.data('owl.carousel');
        if (owlData) {
          owlData.options.touchDrag = false;
          owlData.options.mouseDrag = false;
        }
      }
      
      function enableCarouselDrag() {
        if (!$carousel) return;
        var owlData = $carousel.data('owl.carousel');
        if (owlData) {
          owlData.options.touchDrag = true;
          owlData.options.mouseDrag = true;
        }
      }

      function refreshZoomEligibility() {
        var enabled = !state.zoomDisabled && img.dataset.zoomFailed !== 'true';

        state.maxScale = enabled ? 3 : 1;
        img.classList.toggle('pdp-zoom-eligible', enabled);

        if (state.scale > state.maxScale) {
          state.scale = state.maxScale;
          applyTransform();
        }

        return enabled;
      }

      function markZoomFailed() {
        state.imageStatus = 'failed';
        state.zoomDisabled = true;
        resetZoomInteraction();
        img.dataset.zoomFailed = 'true';
        img.classList.remove('pdp-zoom-eligible');

        var activeImage = document.querySelector('#sync1 .owl-item.active .product-main-image');
        if (activeImage === img) hideZoomIcon();
      }

      function resetZoomInteraction() {
        state.pinchActive = false;
        state.isZooming = false;
        state.isPanning = false;
        state.preventCarouselReset = false;
        state.scale = 1;
        state.posX = 0;
        state.posY = 0;
        img.style.transform = '';
        enableCarouselDrag();
      }

      function waitForImage(image) {
        if (image.complete) {
          return image.naturalWidth ? Promise.resolve(image) : Promise.reject(new Error('Image failed to load'));
        }

        return new Promise(function(resolve, reject) {
          image.addEventListener('load', function() {
            resolve(image);
          }, { once: true });
          image.addEventListener('error', function() {
            reject(new Error('Image failed to load'));
          }, { once: true });
        });
      }

      // Keep the responsive image already rendered on mobile. Swapping to the
      // separately resized master during a pinch can alter fine weave patterns.
      function loadCurrentImageForTouch() {
        if (state.imageStatus === 'ready') return Promise.resolve(true);
        if (state.imageStatus === 'failed') return Promise.resolve(false);
        if (state.imagePromise) return state.imagePromise;

        state.imageStatus = 'loading';
        state.imagePromise = waitForImage(img)
          .then(function() {
            state.imageStatus = 'ready';
            if (state.pinchActive) {
              state.startDistance = state.latestPinchDistance;
              state.startScale = state.scale;
              state.isZooming = true;
              state.userInteracted = true;
            }
            return true;
          })
          .catch(function() {
            markZoomFailed();
            return false;
          });

        return state.imagePromise;
      }
      
      // Get touch center point
      function getTouchCenter(touches) {
        return {
          x: (touches[0].clientX + touches[1].clientX) / 2,
          y: (touches[0].clientY + touches[1].clientY) / 2
        };
      }
      
      // Get distance between two touches
      function getDistance(touch1, touch2) {
        var dx = touch1.clientX - touch2.clientX;
        var dy = touch1.clientY - touch2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }
      
      // Constrain position within bounds
      function constrainPosition(x, y, scale) {
        var rect = container.getBoundingClientRect();
        var imgWidth = img.offsetWidth;
        var imgHeight = img.offsetHeight;
        
        // Calculate max translation based on scale
        var maxX = (imgWidth * scale - imgWidth) / 2;
        var maxY = (imgHeight * scale - imgHeight) / 2;
        
        // Constrain X
        if (x > maxX) x = maxX;
        if (x < -maxX) x = -maxX;
        
        // Constrain Y
        if (y > maxY) y = maxY;
        if (y < -maxY) y = -maxY;
        
        return { x: x, y: y };
      }
      
      // Apply transform
      function applyTransform() {
        var constrained = constrainPosition(state.posX, state.posY, state.scale);
        state.posX = constrained.x;
        state.posY = constrained.y;
        
        img.style.transform = 'translate(' + state.posX + 'px, ' + state.posY + 'px) scale(' + state.scale + ')';
      }
      
      // Touch start
      img.addEventListener('touchstart', function(e) {
        state.moveDistance = 0; // Reset movement tracking
        
        if (e.touches.length === 2) {
          if (!refreshZoomEligibility()) return;

          // Two fingers - pinch zoom: block scroll and carousel
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          state.pinchActive = true;
          state.latestPinchDistance = getDistance(e.touches[0], e.touches[1]);
          state.isZooming = state.imageStatus === 'ready';
          state.isPanning = false;
          state.userInteracted = state.imageStatus === 'ready';
          state.preventCarouselReset = true;
          state.moveDistance = 100; // Prevent accidental double-tap detection on release
          state.startDistance = state.latestPinchDistance;
          state.startScale = state.scale;
          disableCarouselDrag();
          loadCurrentImageForTouch();
          
        } else if (e.touches.length === 1) {
          // Capture start position for tap detection
          state.startX = e.touches[0].clientX;
          state.startY = e.touches[0].clientY;
          
          if (state.scale > 1) {
            // One finger on a zoomed image - pan, block scroll
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            state.isPanning = true;
            state.isZooming = false;
            state.preventCarouselReset = true;
            state.lastTouchX = e.touches[0].clientX;
            state.lastTouchY = e.touches[0].clientY;
            disableCarouselDrag();
          }
          // scale === 1: single finger, do nothing — let browser scroll freely
        }
      }, { passive: false });
      
      // Touch move
      img.addEventListener('touchmove', function(e) {
        // Track movement for tap detection
        if (e.touches.length === 1) {
           var dx = e.touches[0].clientX - state.startX;
           var dy = e.touches[0].clientY - state.startY;
           state.moveDistance = Math.sqrt(dx*dx + dy*dy);
        }

        // Single finger at scale=1: let browser handle scroll freely
        if (e.touches.length === 1 && state.scale <= 1) return;

        if (state.pinchActive && e.touches.length === 2) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          var currentDistance = getDistance(e.touches[0], e.touches[1]);
          state.latestPinchDistance = currentDistance;
          if (!state.isZooming || state.imageStatus !== 'ready') return;

          var newScale = state.startScale * (currentDistance / state.startDistance);
          
          // Touch zoom remains available up to 3x for every loaded image.
          newScale = Math.max(1, Math.min(state.maxScale, newScale));
          state.scale = newScale;
          
          applyTransform();
          
        } else if (state.isPanning && e.touches.length === 1 && state.scale > 1) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          var deltaX = e.touches[0].clientX - state.lastTouchX;
          var deltaY = e.touches[0].clientY - state.lastTouchY;
          
          state.posX += deltaX;
          state.posY += deltaY;
          
          state.lastTouchX = e.touches[0].clientX;
          state.lastTouchY = e.touches[0].clientY;
          
          applyTransform();
        }
      }, { passive: false });
      var lastTap = 0;
      var doubleTapTimeout = null;

      function handleTouchEnd(e) {
        if (e.touches.length < 2) {
          state.pinchActive = false;
        }

        // 1. Handle Double Tap Logic FIRST
        var isDoubleTap = false;
        var currentTime = new Date().getTime();
        var tapLength = currentTime - lastTap;

        // If moved significantly (>2px), this is a pan/zoom, not a tap
        // Reduced threshold to prevent accidental double-taps during small pans
        if (state.moveDistance < 2 && e.touches.length === 0) {
             if (tapLength < 300 && tapLength > 0) {
                isDoubleTap = true;
             }
             lastTap = currentTime;
        } else {
             lastTap = 0; // Reset tap timer if we moved
        }

        if (isDoubleTap) {
             // Double tap detected - reset zoom
             if (doubleTapTimeout) clearTimeout(doubleTapTimeout);
             
             state.scale = 1;
             state.posX = 0;
             state.posY = 0;
             state.userInteracted = false;
             state.preventCarouselReset = false;
             img.style.transition = 'transform 0.3s ease';
             applyTransform();
             
             doubleTapTimeout = setTimeout(function() {
                img.style.transition = '';
                // Re-enable carousel after reset
                enableCarouselDrag();
             }, 300);
             
             state.isZooming = false;
             state.isPanning = false;
             state.pinchActive = false;
             return; // Exit early
        }

        // 2. Handle Normal Touch End
        if (e.touches.length === 0) {
          state.isZooming = false;
          state.isPanning = false;
          
          // IMPORTANT: Don't re-enable carousel if user has zoomed
          // Only re-enable carousel if zoom is at 1x (not zoomed)
          // Use a small tolerance for float comparison
          if (state.scale <= 1.01) {
            state.preventCarouselReset = false;
            enableCarouselDrag();
          } else {
            // Keep carousel disabled while zoomed
            state.preventCarouselReset = true;
          }
        }
      }

      img.addEventListener('touchend', handleTouchEnd);
      img.addEventListener('touchcancel', handleTouchEnd);
      
      // Reset zoom when carousel changes (thumbnail clicked ONLY)
      if ($carousel) {
        $carousel.on('changed.owl.carousel', function() {
          setTimeout(function() {
            var activeImage = document.querySelector('#sync1 .owl-item.active .product-main-image');

            if (activeImage !== img) {
              state.scale = 1;
              state.posX = 0;
              state.posY = 0;
              state.userInteracted = false;
              state.preventCarouselReset = false;
              state.isZooming = false;
              state.isPanning = false;
              state.pinchActive = false;
              img.style.transform = '';
              if (!activeImage) enableCarouselDrag();
              return;
            }

            refreshZoomEligibility();
            if (state.scale <= 1.05 && !state.isZooming && !state.isPanning) {
              state.preventCarouselReset = false;
              enableCarouselDrag();
            }
          }, 0);
        });
      }

      var resizeTimer = null;
      function scheduleTouchRefresh() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          var activeImage = document.querySelector('#sync1 .owl-item.active .product-main-image');
          if (activeImage !== img) return;

          refreshZoomEligibility();
          showZoomIconWhenImageIsRendered();
        }, 100);
      }

      window.addEventListener('resize', scheduleTouchRefresh, { passive: true });
      window.addEventListener('orientationchange', scheduleTouchRefresh, { passive: true });

      refreshZoomEligibility();
    });
  }
  
  // Initialize when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConstrainedPinchZoom);
  } else {
    initConstrainedPinchZoom();
  }
})();
